import React, { useState } from 'react'
import { useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import CustomTooltip from '../CustomTooltip'
import {
  Box,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Typography,
  Radio,
  RadioGroup,
  Select,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { SURVEY_FORM } from './queries'

const useStyles = makeStyles((theme) => ({
  questionFormWrapper: {
    marginTop: '3rem',
  },
  visualizationType: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '1rem',
  },
  visualizationLegend: {
    color: theme.palette.text.secondary,
    fontWeight: 600,
    margin: '10px 0'
  }
}))

function SurveyFilter(props) {
  if (!props.surveyId) return null

  const classes = useStyles()
  const {
    sector,
    setSector,
    subtopic,
    setSubtopic,
    subtopics,
    setSubtopics,
    topic,
    setTopic,
    dimension,
    setDimension,
    visualizationType,
    setVisualizationType,
  } = props

  console.log(subtopics);
  const [allSectors, setAllSectors] = useState(undefined)

  const { loading, error, data } = useQuery(SURVEY_FORM, {
    variables: { surveyId: props.surveyId.id }
  })

  const subtopicsForCurrentTopicAndSector = (topic, sector) => {
    const subtopicsForCurrentSector = [...new Set(
      data
        .subtopicsPerSectors
        .filter(subtopic => subtopic.sectorId === sector)
        .map(e => e.tag)
    )]
    if(visualizationType === 'newModel') {
      return data
        .surveyForm
        .allTopics.find(_topic => _topic.id === topic)
        .subtopics
        .filter(subtopic => {
          if (sector === 0) return true
          return subtopicsForCurrentSector
            .find(subtopicId => subtopicId.id === subtopic.id)
        })
        .sort((a, b) => a.name.localeCompare(b.name))
    }else {
      return subtopicsForCurrentSector
    }
  }

  const handleTopicChange = (event) => {
    const selectedTopic = typeof event === 'number' ? event : event.target.value

    setTopic(selectedTopic)
    setSubtopic(0)
    setSubtopics(
      subtopicsForCurrentTopicAndSector(selectedTopic, sector)
    )
  }

  const handleSectorChange = (event) => {
    setSector(event.target.value)
    setSubtopics(
      subtopicsForCurrentTopicAndSector(topic, event.target.value)
    )
  }

  if (error) {
    return <Typography>Erro ao carregar - { error.message }</Typography>
  }

  if (loading) {
    return (
      <Grid container justify="center">
        <Grid item xs={ 1 }>
          <Box mt={ 5 }>
            <CircularProgress />
          </Box>
        </Grid>
      </Grid>
    )
  }

  if (!dimension && !_.isEmpty(data.surveyForm.allDimensions)) {
    setDimension(data.surveyForm.allDimensions[0].id)
  }

  if (!topic && !_.isEmpty(data.surveyForm.allTopics)) {
    const defaultTopic = data.surveyForm.allTopics[0]
    handleTopicChange(defaultTopic.id)
  }

  if (!allSectors && !_.isEmpty(data.surveyForm.allSectors)) {
    setAllSectors(data.surveyForm.allSectors.sort((a, b) => a.b3Name.localeCompare(b.b3Name)) )
  }

  return (
    <Grid container fullWidth>
      <Grid item xs={ 12 }>
        <Grid item xs={ 12 } md={ 3 }>
          <CustomTooltip title="Escolha o setor de seu interesse, ou “todos os setores” para uma visão geral">
            <FormControl variant="outlined" fullWidth>
              <InputLabel>Setor</InputLabel>
              <Select
                value={ sector }
                onChange={ handleSectorChange }
                label="Escolha um setor"
              >
                <MenuItem key={ 0 } name="Todos os Setores" value={ 0 }>Todos os Setores</MenuItem>
                {
                  allSectors && allSectors.map((sector, key) =>
                    <MenuItem key={ key } value={ sector.id }>{ sector.b3Name }</MenuItem>)
                }
              </Select>
            </FormControl>
          </CustomTooltip>
        </Grid>
      </Grid>
      <Grid item xs={ 12 }>
        <Grid container>
          <Grid item xs={ 12 }>
            <FormLabel className={ classes.visualizationLegend } component="legend">
              Visualização
            </FormLabel>
          </Grid>
          <Grid item xs={ 12 }>
            <FormControl variant="outlined" fullWidth>
              <FormControl component="fieldset">
                <RadioGroup
                  aria-label="visualization"
                  value={ visualizationType }
                  onChange={ event => setVisualizationType(event.target.value) }
                  row
                >
                  <Grid container item xs={ 12 } justify="flex-start">
                    <Grid item xs={ 12 } md={ 8 }>
                      <FormControl className={ classes.visualizationType } variant="outlined">
                        <Grid container item direction="column">
                          {/* <CustomTooltip title="Mostra as perguntas do questionário atual, mas FILTRADAS E AGRUPADAS pelos temas">
                            <FormControlLabel value="newModel" control={ <Radio /> } label="Temática" />
                          </CustomTooltip> */}

                          <Grid container item direction="row" spacing={ 2 }>
                            {/* <Grid item xs={ 12 } md={ 4 }>
                              <CustomTooltip title="Escolha a DIMENSÃO que quer visualizar">
                                <Select
                                  fullWidth
                                  value={ topic }
                                  onChange={ handleTopicChange }
                                  label="Todas as dimensões"
                                  disabled={ visualizationType === 'standard' }
                                >
                                  {
                                    data.surveyForm.allTopics.map((topic, key) =>
                                      <MenuItem key={ key } value={ topic.id }>
                                        { topic.name }
                                      </MenuItem>)
                                  }
                                </Select>
                              </CustomTooltip>
                            </Grid> */}

                            <Grid item xs={ 12 } md={ 4 }>
                              <CustomTooltip title="Escolha o TEMA que quer visualizar">
                                <Select
                                  fullWidth
                                  value={ subtopic }
                                  onChange={ event => setSubtopic(event.target.value) }
                                  label="Todos os temas"
                                  disabled={ visualizationType === 'standard' }
                                >
                                  <MenuItem key={ -1 } value={ 0 }>
                                    Todos os temas
                                  </MenuItem>

                                  {
                                    subtopics.map((subtopic, key) =>
                                      <MenuItem key={ key } value={ subtopic.id }>
                                        { subtopic.name }
                                      </MenuItem>
                                    )
                                  }

                                </Select>
                              </CustomTooltip>
                            </Grid>
                          </Grid>
                        </Grid>
                      </FormControl>
                    </Grid>
                  </Grid>
                </RadioGroup>
              </FormControl>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
      { props.children }
    </Grid>
  )
}

export default SurveyFilter
